import { Controller } from "stimulus";

export default class extends Controller {
  static targets = ["saveButton"];

  connect() {
    $(this.element)
      .find("select.search-select-input")
      .on("select2:select select2:unselect select2:clear", function () {
        this.dispatchEvent(new Event("change", { bubbles: true }));
      });
  }

  reveal() {
    this.saveButtonTarget.style.display = "";
  }
}
